import React from 'react';
import Pdfimg from './img2pdf/Pdfimg';

const App = () => {
  return (
    <div>
      <Pdfimg />
    </div>
  );
};

export default App;
